import React from 'react';
import { withPrefix } from 'gatsby';
import {
  wrapper,
  customStepper,
  customStepperTitle,
  customStepperTitleActive,
  customStepperItem,
  customStepperItemActive,
  customStepperItemAfter,
  customStepperItemLineActive,
  spring
} from './StepperStyles';

type ItemProps = {
  id: string;
  label: string;
  href: string | null;
  status: "Completed" | "In Progress" | "Yet to complete";
};

type StepperProps = {
  id?: string;
  items: ItemProps[];
  location: Location;
};

const SectionStepper = ({ items, location }: StepperProps) => {


  return (
    <div css={spring}>
      <div css={wrapper}>
        <ol className="steppers_list" css={customStepper}>
          {
            items.map((item, index) => {
              const { id, label, href, status } = item;
              let StepperTitleCSS;
              const StepperItemCSS = [];
              let getLinkLabel;
              const nextItem = index + 1;
              if (status === "Completed" || status === "In Progress") {
                StepperTitleCSS = customStepperTitleActive;
                StepperItemCSS.push(customStepperItem, customStepperItemActive, customStepperItemAfter);
              } else {
                StepperTitleCSS = customStepperTitle;
                StepperItemCSS.push(customStepperItem, customStepperItemAfter);
              };
              if (items[nextItem] && (items[nextItem].status === "Completed" || items[nextItem].status === "In Progress")) {
                StepperItemCSS.push(customStepperItemLineActive);
              };
              if (status === "Completed" && href) {
                getLinkLabel = (
                  <a href={location?.origin
                    ? location.origin + withPrefix(href)
                    : withPrefix(href)
                  }>{label}</a>
                );
              } else {
                getLinkLabel = label;
              };

              return (
                <li className="steppers_item" key={id} css={StepperItemCSS} >
                  <h3 css={StepperTitleCSS}>
                    {getLinkLabel}
                  </h3>
                </li>
              )
            })
          }
        </ol>
      </div>
    </div>
  );
};

export default SectionStepper;
